<div class="file-upload-wrapper">
  <div class="row">
    <!-- File Input Section -->
    <div
      class="col-sm-6"
      [class]="customClass"
      style="padding-right: 0px"
      [ngClass]="{ 'disabled-project': isDisabled }"
    >
      <div class="fileinput fileinput-new">
        <div class="input-group input-large">
          <div
            class="form-control uneditable-input d-flex justify-content-flex-start align-items-center text-decoration-underline"
            data-trigger="fileinput"
          >
            <i class="fa fa-file fileinput-exists" *ngIf="isShowChange"></i>
            <span *ngIf="displayFileName" class="fileinput-filename"
              >&nbsp; {{ displayFileName }}</span
            >
            <span *ngIf="!displayFileName" class="fileinput-filename"
              ><label class="input-center">{{ mergedConfig.placeholderText }}</label></span
            >
          </div>
          <span class="btn default btn-file" style="padding: 3.8px 0">
            <input
              type="file"
              #hiddenfileinput
              [accept]="acceptAttribute"
              (change)="fileChangeEvent($event)"
              style="display: none"
              [disabled]="isDisabled"
            />
            <button
              class="btn-style waves-effect btn selectFile"
              (click)="onSelectClick()"
              *ngIf="!isShowChange && !existingFileUrl"
              [disabled]="isDisabled"
              type="button"
            >
              {{ mergedConfig.selectButtonText }}
            </button>
            <button
              class="btn-width waves-effect waves-light btn changeFile"
              *ngIf="isShowChange || existingFileUrl"
              (click)="onChangeClick()"
              [disabled]="isDisabled"
              type="button"
            >
              {{ mergedConfig.changeButtonText }}
            </button>
          </span>
          <button
            class="waves-effect waves-light btn removeImage"
            (click)="onRemoveClick()"
            *ngIf="isShowChange || existingFileUrl"
            [disabled]="isDisabled"
            type="button"
          >
            {{ mergedConfig.removeButtonText }}
          </button>
        </div>
      </div>

      <div [ngClass]="{ 'disabled-project': isDisabled }" *ngIf="showError">
        <span id="PiqetValidationSummary" class="field-validation-error">
          {{ errorMessage }}
        </span>
      </div>
    </div>

    <!-- Image Preview Section - Same row, to the right -->
    <div class="col-sm-6" *ngIf="showImage">
      <div class="image-preview-container" [ngClass]="{ 'disabled-project': isDisabled }">
        <div class="image-preview-wrapper">
          <div class="cross-position" (click)="onCrossClick()">
            <img src="./assets/icons/pop-up-cross.svg" class="cross-icon" width="15" height="15" />
          </div>
          <img [src]="displayImageUrl" width="120" height="120" class="preview-image" />
        </div>
      </div>
    </div>
  </div>
</div>
